import {
    BasicInfoBeneficiary,
    TermsBeneficiary,
    DocumentsBeneficiary,
    ObjectionBeneficiary,
    ObjectionEvaluationFormAuditor,
    } from './components';
  
  export const stepsObjectionManual = [
    {
      name: 'BASICFORM',
      label: 'Βασικά Στοιχεία',
      Component: BasicInfoBeneficiary,
      id: 0,
    },
    {
      name: 'DOCUMENTS',
      label: 'Έγγραφα',
      Component: DocumentsBeneficiary,
      id: 1,
    },
    {
      name: 'TERMS',
      label: 'Όροι και Προϋποθέσεις',
      Component: TermsBeneficiary,
      id: 2,
    },
    {
      name: 'OBJECTIONFORM',
      label: 'Ένσταση',
      Component: ObjectionBeneficiary,
      id: 3,
    },
    {
       name: 'OBJECTIONEVALUATIONFORM',
      label: 'Εξέταση Ένστασης',
      Component: ObjectionEvaluationFormAuditor,
      id: 4,
    }
  ];